import { motion } from "framer-motion";

export default function IbcSection() {
  return (
    <section className="relative py-24 lg:py-32 border-y border-zinc-800/60 bg-[#0d0d0d] overflow-hidden" data-testid="ibc-section">
      <span className="pointer-events-none select-none absolute -bottom-10 left-0 font-display text-[26vw] leading-none uppercase text-white/[0.025] whitespace-nowrap">
        Sanctioned
      </span>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative">
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-4 flex justify-center"
        >
          <div className="relative p-10 border border-zinc-800 bg-[#0a0a0a]">
            <div className="absolute inset-0 border border-[#E10600]/30 translate-x-2 translate-y-2 -z-10" />
            <img src="/images/ibc-logo.webp" alt="Official IBC — Indian Boxing Council logo" className="h-44 w-44 sm:h-56 sm:w-56 object-contain" data-testid="ibc-logo-image" />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-8"
        >
          <p className="font-mono2 text-[10px] sm:text-xs tracking-[0.4em] text-[#E10600] uppercase mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#E10600]" /> Official Affiliation
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white">
            Affiliated with <span className="text-[#E10600]">IBC</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-2xl" data-testid="ibc-description">
            Masters Pro Boxing is an independent organization, <span className="text-white font-medium">proudly affiliated with the Indian Boxing Council (IBC)</span> —
            the professional sanctioning body of Indian boxing. Through this affiliation, every MPB license, ranking and
            masters division title bout follows IBC sanctioning standards, with recorded results and championship-grade oversight.
          </p>
          <div className="mt-8 flex flex-wrap gap-6 font-mono2 text-[10px] sm:text-xs tracking-[0.25em] uppercase text-zinc-500">
            <span data-testid="ibc-point-1" className="flex items-center gap-2"><span className="h-1.5 w-1.5 rotate-45 bg-[#E10600]" /> IBC Sanctioning Standards</span>
            <span data-testid="ibc-point-2" className="flex items-center gap-2"><span className="h-1.5 w-1.5 rotate-45 bg-[#E10600]" /> Recorded Bout Results</span>
            <span data-testid="ibc-point-3" className="flex items-center gap-2"><span className="h-1.5 w-1.5 rotate-45 bg-[#E10600]" /> Title Bout Eligibility</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
